






import { Component, Vue } from "vue-property-decorator";
import CustomForm from "./components/CustomForm.vue";

@Component({
  components: {
    CustomForm,
  },
})
export default class App extends Vue {}
